<template>
  <div>
      打印机
  </div>
</template>
<script>
  export default {
    components: {},
    data () {
      return {

      }
    },

    mounted: function() {
      //DOM更新完后再请求数据
      this.$nextTick(function() {

      });
    },
    created: function() {
      //DOM更新完之前请求数据


    },
    methods: {

    }
  }
</script>


<style  lang="scss" scoped>
.server-title{
    font-size: 20px;display: inline-block; text-align: center;width: 88%
}
.server-item li{
    margin:0 auto 26px;
    position: relative;
    width: 328px;
    height: 75px;
    border-radius: 5px;
    box-shadow: 0px 3px 10px 0px rgba(24, 54, 129, 0.14);
    padding-left: 75px;
    line-height: 75px;
    color: #333333;
    img{
        position: absolute;
        left: 14px;
        top: 12px;
        width: 50px;
        height: 50px;
    }
    Button{
        position: absolute;
        top: 25px;
        right: 15px;
    }
}
</style>